// Marketplace categories with descriptions (used by Sell view + listing form)
export const KIT_CATEGORIES = [
  { key: 'shoes', label: 'Running shoes', hint: 'Trainers, spikes, road & trail shoes' },
  { key: 'apparel', label: 'Clothing & apparel', hint: 'Tops, shorts, jackets, tri suits' },
  { key: 'tech', label: 'Watches & tech', hint: 'GPS watches, HR straps, sensors' },
  { key: 'cycling', label: 'Cycling gear', hint: 'Bikes, wheels, helmets, jerseys' },
  { key: 'hydration', label: 'Hydration & nutrition', hint: 'Bottles, flasks, gels, fuel' },
  { key: 'bag', label: 'Bags & packs', hint: 'Race vests, kit bags, backpacks' },
  { key: 'other', label: 'Other kit', hint: 'Anything else training related' }
];

export const kitCategoryLabel = (key) => (KIT_CATEGORIES.find(c => c.key === key) || {}).label || 'Kit';

// Normalises a listing price for display: bare numbers get a £, 0/blank shows as Free
export const formatListingPrice = (price) => {
  const trimmed = String(price ?? '').trim();
  if (!trimmed) return 'Free';
  if (/^\d+(\.\d+)?$/.test(trimmed)) return Number(trimmed) <= 0 ? 'Free' : `£${trimmed}`;
  return trimmed;
};

// Only plain numeric prices ("25" or "£25") support the "Was X now Y" reduction flow
export const isNumericPrice = (price) => /^£?\d+(\.\d+)?$/.test(String(price ?? '').trim());

// Numeric value of a price string, stripping any leading £ (for comparisons/inputs)
export const numericPriceValue = (price) => parseFloat(String(price ?? '').trim().replace(/^£/, ''));
